import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import styled from 'styled-components';

import { ProductDuration } from 'utils/services/VervAPI';
import { useT } from '@hooks';
import { appStore } from '@store';

interface Props {
	periodText?: string;
	fullPriceText?: string;
	currency?: string;
	withRenewalText?: boolean;
	duration?: ProductDuration;
	fullPrice?: number;
}

const Container = styled.div`
	font-weight: 300;
	font-size: 12px;
	line-height: 14px;
	color: ${({ theme }) => theme.colors.text1};
	text-align: left;

	& a {
		text-decoration: underline;
		color: ${({ theme }) => theme.colors.text7};
	}
`;

const Description = styled.div`
	color: #bcbcbc;
`;

export const Agreements: FC<Props> = observer(props => {
	const { withRenewalText = true, duration, fullPrice } = props;
	const { T } = useT();
	const [periodText, setPeriodText] = useState('month');
	const [fullPriceText, setFullPriceText] = useState('');
	const { product: paymentModal } = appStore.paymentStore;

	useEffect(() => {
		const durationToUse = duration ?? paymentModal.details?.duration;

		if (durationToUse != null) {
			if (durationToUse.unit === 'month') {
				const periodTextMonth =
					(durationToUse.value ?? 0) > 1
						? durationToUse.value === 6
							? T('tariff_months_variable')
							: T('tariff_months')
						: T('tariff_month');
				setPeriodText(`${durationToUse.value ?? ''} ${periodTextMonth}`);
			} else {
				const periodTextWeek =
					(durationToUse.value ?? 0) > 1 ? T('tariff_weeks') : T('tariff_week');
				setPeriodText(`${durationToUse.value ?? ''} ${periodTextWeek}`);
			}
		}

		if (paymentModal.details?.amount) {
			setFullPriceText(`${props.currency ?? ''} ${fullPrice ?? paymentModal.details.amount}`);
		}
	});
	return (
		<Container>
			{withRenewalText && (
				<Description
					dangerouslySetInnerHTML={{
						__html: T('get_my_plan_warning_text')
							.replace('__period__', props.periodText ?? periodText)
							.replace('__fullPriceText__', props.fullPriceText ?? fullPriceText),
					}}
				/>
			)}
		</Container>
	);
});
